import { Container } from 'unstated'

class AppContainer extends Container {
  state = {
    orderModalIsOpen: false,
  }

  openOrderModal = () => {
    document.querySelector('html').style.overflow = 'hidden'
    this.setState({ orderModalIsOpen: true })
  }

  closeOrderModal = () => {
    document.querySelector('html').removeAttribute('style')
    this.setState({ orderModalIsOpen: false })
  }
}

export default AppContainer



// WEBPACK FOOTER //
// ./src/components/AppContainer.js